import React from 'react';
import '../Placeholder/Placeholder.css'

export default () => <div className="__placeholder"></div>